import React from 'react';

import '../../App.css';

const sideBarBackDrop = (props) => <div className="backdrop" onClick={props.click} />;

export default sideBarBackDrop;
